import { useLocation, useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export const FloatingChatButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const hiddenPaths = ["/chat", "/login", "/signup"];
  if (hiddenPaths.includes(location.pathname)) return null;

  return (
    <button
      onClick={() => navigate("/chat")}
      aria-label="Open Charlie chat"
      style={{bottom: '1rem', right: '1rem'}}
      className="fixed z-50 w-12 h-12 rounded-full dark:bg-sy-teal bg-teal-600 dark:text-sy-navy text-white shadow-lg dark:shadow-sy-teal/30 shadow-teal-600/30 flex items-center justify-center hover:brightness-110 active:scale-95 transition-all duration-150"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
};
